import * as React from 'react';
import { SVGProps } from 'react';

const IconStringSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 2H3v2h10V2ZM13 5H3v2h10V5ZM11 8H5v1.2L3 10v2l-1 1.023a2.261 2.261 0 0 0 2.261 2.26h.347L5 14.5h1.5l.392.784h2.216L9.5 14.5H11l.392.784h.347A2.261 2.261 0 0 0 14 13.023L13 12v-2l-2-.8V8Z" />
  </svg>
);
export default IconStringSizeS;
